export const environment = {
  production: false,
  titol: "Gestió IT Ingrés Hospitalari",
  urlAPI: "https://gestioit.sjdhospitalbarcelona.org:3000",
  ajuda: "",
  suport: "http://cau",
  serveiPacient: "si",
  miraUltima: 300,
  navBarColor: "#004488",
  confirmacions: true,
  correccioDataPart: true,
  logServidorBd: true,
  logICAMBd: true
};
